import { render, staticRenderFns } from "./doctor-dialog.vue?vue&type=template&id=1d049b1c&"
import script from "./doctor-dialog.vue?vue&type=script&lang=js&"
export * from "./doctor-dialog.vue?vue&type=script&lang=js&"
import style0 from "./doctor-dialog.vue?vue&type=style&index=0&id=1d049b1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports